import { appApiSlice } from 'src/api/app-ApiSlice';
import { TAG_FLOOR_ROOMS_AND_RELATED } from 'src/api/api-tags';

export const deviceApiSlice = appApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createAutomaticallyElectricalAndRackCabinet: builder.mutation<{ status: number; message: string }, number>({
            query: (projectId: number) => ({
                url: `v1/device/create-automatically-electrical-and-rack-cabinet`,
                method: 'POST',
                body: {
                    project_id: projectId,
                },
            }),
            invalidatesTags: [{ type: TAG_FLOOR_ROOMS_AND_RELATED }],
        }),
    }),
    overrideExisting: false,
});

export const {
    useCreateAutomaticallyElectricalAndRackCabinetMutation,
} = deviceApiSlice;
